/**
 * Черновик анкеты регистрации.
 *
 * Потеря ввода стоит партнёра. Вкладку закрывают, страницу перезагружают,
 * код приходит на телефон и человек уходит его искать; всё это происходит
 * между шагом 2 и отправкой анкеты.
 *
 * Черновик привязан к номеру: на одном компьютере кабинет может заводить не
 * один человек, и подставлять чужое заведение нельзя.
 *
 * Отдельно хранится сам номер: `409 registration_incomplete` прилетает без
 * него, а без номера непонятно, какой черновик открывать.
 */

const DRAFT_PREFIX = 'registrationDraft:';

/** Ключ читает и `clearStoredSession` в `apiErrors` — менять только вместе. */
const PENDING_PHONE_KEY = 'registrationPhone';

export interface RegistrationDraft {
  venue_name?: string;
  venue_address?: string;
  city_id?: number | null;
  category_id?: number | null;
  /** Точка, поставленная на карте. */
  latitude?: number | null;
  longitude?: number | null;
  /** Адрес, который анкета подставила по точке, — чтобы знать, вводил ли его партнёр. */
  venue_address_by_point?: string | null;
}

export function readDraft(phone: string): RegistrationDraft {
  if (!phone) return {};
  try {
    const raw = localStorage.getItem(DRAFT_PREFIX + phone);
    return raw ? (JSON.parse(raw) as RegistrationDraft) : {};
  } catch {
    // Битый черновик — не повод ронять анкету: начнём с пустой.
    return {};
  }
}

export function writeDraft(phone: string, draft: RegistrationDraft): void {
  if (!phone) return;
  try {
    localStorage.setItem(DRAFT_PREFIX + phone, JSON.stringify(draft));
  } catch {
    // Приватный режим или переполненное хранилище: черновик — удобство,
    // а не условие работы формы.
  }
}

export function clearDraft(phone: string): void {
  if (!phone) return;
  localStorage.removeItem(DRAFT_PREFIX + phone);
}

/** Номер, на котором остановилась незаконченная регистрация. */
export function getPendingPhone(): string | null {
  return localStorage.getItem(PENDING_PHONE_KEY);
}

export function setPendingPhone(phone: string): void {
  localStorage.setItem(PENDING_PHONE_KEY, phone);
}

export function clearPendingPhone(): void {
  localStorage.removeItem(PENDING_PHONE_KEY);
}
